// Template Excel import item MCR -- file di src/assets/template_import_excel, dipilih per company + mcr_type dari nama file:
// "Template Import MCR Items - <COMPANY> <MCR_TYPE>.xlsx" (mis. "... - ANTAM MCR001.xlsx"). Tambah template baru = taruh file
// dengan pola nama itu, tanpa ubah kode. File .xlsx dibundel webpack sebagai asset (aturan di vue.config.js).
const templateContext = require.context('@/assets/template_import_excel', false, /\.xlsx$/);

const templateName = (company, mcrType) =>
  `Template Import MCR Items - ${String(company || '').toUpperCase()} ${String(mcrType || '').toUpperCase()}.xlsx`;

// URL asset template untuk company + mcr_type, atau null kalau belum ada filenya.
export const findImportTemplate = (company, mcrType) => {
  const key = `./${templateName(company, mcrType)}`;
  return templateContext.keys().includes(key) ? templateContext(key) : null;
};

// Untuk `templateService` store importExcel: bentuk { data: Blob, headers } supaya nama file ikut ter-download.
export const downloadImportTemplate = async (company, mcrType) => {
  const url = findImportTemplate(company, mcrType);
  if (!url) throw new Error('Template is not available for this MCR type');
  const response = await fetch(url);
  if (!response.ok) throw new Error('Failed to download template');
  return {
    data: await response.blob(),
    headers: { 'content-disposition': `attachment; filename="${templateName(company, mcrType)}"` }
  };
};
